import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomFieldConfig, SharedModule } from '@vendure/admin-ui/core';

@Component({
  selector: 'ft-hidden-input',
  imports: [SharedModule],
  template: `<div style="display:none;"></div>`,
  standalone: true,
})
export class HiddenInputComponent implements OnInit {
  readonly: boolean;
  config: CustomFieldConfig;
  formControl: FormControl;
  constructor() {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {}
}
